import { render, staticRenderFns } from "./BannerContact.vue?vue&type=template&id=af6eda52&scoped=true&"
import script from "./BannerContact.vue?vue&type=script&lang=js&"
export * from "./BannerContact.vue?vue&type=script&lang=js&"
import style0 from "./BannerContact.vue?vue&type=style&index=0&id=af6eda52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6eda52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
